/*
 * @Description: 类型、状态等枚举
 */

// 费用类型
export const TrainFeeType = {
  original: 0,
  change: 1, // 改签
  refund: 2 // 退票
}

//支付类型
export const TrainPayType = {
  companyPay: 0,
  personalPay: 1,
  mixPay: 2
}

//使用pascal命名枚举
export const TrainSupplier = {
  //滴滴 天骐
  SUPPLIER_12306: 10001,
  //其他外部用户
  SUPPLIER_HANGTIAN: 10002
}

//使用pascal命名枚举 订单状态枚举映射有问题
// 以下是订单实际的一些值 ✅的是代码用到的值
// 已完成 4
// 订单关闭 5
// 已取消 7 

// 占座中 21
// 待支付 2
// 待出票 22
// 已出票 4 
// 改签占座中 23
// 改签待支付 2
// 改签中 4
// 退票中 4
// 已退票 4
export const OrderStatus = {
  UNKNOWN: 0, //未知状态
  FINISHED: 1, //已完成
  BOOKING: 2, //待支付 ✅ 
  PAID: 3, //待出票(已支付) ✅
  ISSUED: 4, //已出票
  REFUNDING: 5, //占座失败 已取消  抢票取消 
  CLOSED: 6, //已关闭 占座失败 new 订单关闭 出票失败 抢票失败 
  REISSUE: 7, //取消 抢票取消
  REISSUING: 8, //改签中  ?
  REISSUED: 9, //已改签 ? q
  OCCUPY_SEAT_FAILURE: 10, //占座失败
  TICKET_OUT_FAILURE: 11, //出票失败
  CHANGE_OCCUPY_SEAT_FAILURE: 12, //改签占座失败
  CHANGE_TICKET_OUT_FAILURE: 13, //改签出票失败
  REFUND_TICKER_NOT_REFUND: 14, //已退票未退款
  REFUND_TICKER_AND_REFUND: 15, //已退票已退款
  OCCUPYING_SEAT: 21, //占座中 占座中已付款✅
  ISSUING: 22, //出票中（待出票占座中 ✅
  CHANGE_OCCUPYING_SEAT: 23,  //改签占座中 ✅
  CHANGE_ISSUING: 24,  //改签占座中
  SCRAMBLE_BOOKING: 16, //抢票待支付 ✅
  SCRAMBLING: 17, //抢票中 ✅
  SCRAMBLE_FAILURE: 18, //抢票失败 
  SCRAMBLE_CANCELLING: 27, //抢票取消中 ✅
}

export const TicketStatus = {
  SUBMITTED: 1,  // 已提交
  BOOK_SUCCESS: 2,  // 预定成功
  PAID: 3,  // 已支付
  ISSUED: 4,  // 已出票 ✅
  BOOK_FAIL_CANCEL: 5,  // 取消
  CANCEL: 6,  // 支付后取消
  BOOK_SUCCESS_CANCEL: 7,  // 预定成功后取消
  REISSUE_SUBMIT: 8,  // 已提交改签申请
  REISSUE: 9,  // 已改签
  REFUND_SUBMIT: 10, // 已提交退票申请
  REFUNDED: 11, // 已退票
  IN_STATION: 12, // 已进站
  OUT_STATION: 13, // 已出站
  OCCUPYING_SEAT: 21, // 占座中
  ISSUING: 22, // 出票中
  OFFLINE_REISSUE: 23, // 已线下改签
  OFFLINE_REFUNDED: 24, // 已线下退票
}

export const travelTypeMap = {
  business: 0,
  private: 1
}

// 手机核验状态
export const TrainMobileStatus = {
  UNVERIFY: 0,
  PASSED: 1,
  FAIL: 2
}

// 机票查询主卡状态
export const FLIGHTS_TYPES = {
  ONE: 1, // 单程
  RT: 2, // 往返
  SP: 3, // 特价
}

// 同程机票jumpurl拼接规则
export const FLIGHTS_URL_TYPES = {
  ONE: 'query-1', // 单程
  RT: 'query-2', // 往返
  SP: 'query-3', // 特价
  SP_MORE: 'more', // 特价机票 - 查看更多
  SP_DETAIL: 'detail', // 特价机票 - 单独选项点击
  ORDER: 'order', // 同程订单列表
  GUIDEBOOK: 'guidebook', // 飞行指南
}